import { Loader2 } from 'lucide-react'
import React, { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { regexType } from '../../sharedfiles/helper'
import { enableTotp, getTotpDetatils } from '../Login/loginSlice'
import { Input, Button } from '../../ui'
import Spinner from '../Common/Spinner/Spinner'
function TotpAuth(props) {
  const [formData, setFormData] = useState({
    totpPin: '',
    passcode: '',
  })
  const [errors, setErrors] = useState({
    totpPin: '',
    passcode: '',
  })
  const [enabled, setEnabled] = useState('Enable')
  const [loading, setLoading] = useState(false)
  const [copy, setCopy] = useState(false)
  const dispatch = useDispatch()
  const totpDetails = useSelector((state) => state.loginSlice.totpData)
  const totpEnabledData = useSelector(
    (state) => state.loginSlice.totpEnabledData,
  )
  const history = useHistory()
  const loginToken = localStorage.getItem('totpToken')
  const authStatus = useSelector((state) => state.loginSlice.authStatus)

  const totpHandler = (e) => {
    const { name, value } = e.target
    if (name === 'totpPin') {
      if (value === '' || regexType.numeric.test(value)) {
        setFormData((prev) => {
          return {
            ...prev,
            [name]: value,
          }
        })
        validator(name, value)
      }
    }
    if (name !== 'totpPin') {
      setFormData((prev) => {
        return {
          ...prev,
          [name]: value,
        }
      })
      validator(name, value)
    }
  }

  const errorSetter = (key, err) => {
    setErrors((prev) => {
      return {
        ...prev,
        [key]: err,
      }
    })
  }
  const validator = (key, val) => {
    if (key === 'totpPin') {
      let err = ''
      if (val === '') err = 'TOTP Pin required'
      else err = ''
      errorSetter(key, err)
    } else {
      let err = ''
      if (val === '') err = 'passcode required'
      else err = ''
      errorSetter(key, err)
    }
  }

  const copyTotpCode = (e) => {
    setCopy(true)
    navigator.clipboard.writeText(totpDetails?.totpSecret)
  }

  const onSubmit = () => {
    validator('totpPin', formData.totpPin)
    validator('passcode', formData.passcode)
    if (formData.totpPin !== '' && formData.passcode !== '') {
      setLoading(true)
      const payload = {
        password: formData.passcode,
        totpPin: formData.totpPin,
        totpToken: totpDetails.totpToken,
      }
      dispatch(enableTotp(payload, loginToken))
    }
  }

  useEffect(() => {
    if (Object.keys(authStatus).length > 0) {
      if (authStatus.status) {
        setEnabled('Enabled')
        setLoading(false)
        setTimeout(() => history.push('login'), 1000)
      } else {
        const isTotpErr = authStatus.field === "totp";
        const key = isTotpErr ? "totpPin" : "passcode";
        const msg = isTotpErr ? "Invalid TOTP Pin" : "Invalid Password";
        errorSetter(key, msg);
        setLoading(false);
      }
    }
  }, [authStatus])

  const copyTimer = () => setTimeout(() => setCopy(false), 1000)

  useEffect(() => {
    if (copy) copyTimer()
  }, [copy])

  useEffect(() => {
    let mounting = true
    if (mounting) {
      if (loginToken) {
        dispatch(getTotpDetatils(props, loginToken))
      } else {
        history.push('login')
      }
    }
    return () => {
      clearTimeout(copyTimer)
      mounting = false
    }
  }, [])

  return (
    <React.Fragment>
      <div className="CMS_totp_container h-screen overflow-y-auto flex bg-gray-50 dark:bg-slate-900 p-[clamp(1rem,5vh,3rem)]">
        <div className="CMS_totp_Wrapper w-full max-w-md m-auto">
          <div className="CMS_totp_content flex flex-col gap-4 rounded-2xl border border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-6 shadow-lg">
            <div className="totp_title text-center text-xl font-bold tracking-wide text-gray-900 dark:text-white">2 FACTOR AUTHENTICATION</div>
            {/* <div className="totp_body"> */}
            <div className="totp_scanner flex flex-col items-center gap-2">
              <img
                className="totp_qr_code h-56 w-56 rounded-lg border border-gray-200 dark:border-slate-700 bg-white"
                src={totpDetails?.totpImg}
                alt="qr-code"
              />
              {/* <span className="totp_qr_text" onClick={copyTotpCode}>
                  Can't scan? Copy the Key
                </span> */}
              <span
                className="totp_qr_text text-sm font-medium text-[#1a86f3] hover:underline cursor-pointer"
                onClick={copyTotpCode}
              >
                {copy ? 'Copied!' : "Can't scan? Copy the Key"}
              </span>
            </div>
            {/* <div className="totp_auth"> */}
            <div className="totp_info_box text-center space-y-1">
              <p className="body_title text-sm font-semibold text-gray-900 dark:text-white">
                Scan the QR code on your authenticator App
              </p>
              <span className="body_subtitle block text-sm text-gray-500 dark:text-gray-400">
                Once scanned, the app should give you a 6 digit TOTP, Enter it
                here
              </span>
            </div>
            {/* <div className="totp_fileds"> */}
            <div className="fields space-y-1.5">
              <div className="totp_code label text-sm font-medium text-gray-700 dark:text-gray-300">TOTP Pin*</div>
              <Input
                type="text"
                id="totp_code"
                name="totpPin"
                maxLength={6}
                placeholder="6 digit TOTP"
                className="totp_input text h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors"
                value={formData.totpPin}
                onChange={totpHandler}
              />
              {errors.totpPin && (
                <p className="text-sm text-destructive mt-1">{errors.totpPin}</p>
              )}
            </div>
            <div className="fields space-y-1.5">
              <div className="passcode label text-sm font-medium text-gray-700 dark:text-gray-300">password*</div>
              <Input
                type="password"
                placeholder="account password"
                name="passcode"
                className="totp_input password h-11 bg-white dark:bg-slate-800 border-gray-200 dark:border-slate-700 focus-visible:ring-[#1a86f3] focus-visible:border-[#1a86f3] transition-colors"
                value={formData.passcode}
                onChange={totpHandler}
              />
              {errors.passcode && (
                <p className="text-sm text-destructive mt-1">{errors.passcode}</p>
              )}
            </div>
            {/* </div> */}
            <div className="totp_buttons w-full">
              <Button
                className={
                  enabled === 'Enabled'
                    ? 'totp_btn_enable success w-full h-11 text-sm font-semibold shadow-md bg-green-600 hover:bg-green-600'
                    : 'totp_btn_enable w-full h-11 text-sm font-semibold shadow-md hover:shadow-lg transition-all duration-200'
                }
                onClick={onSubmit}
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm" />
                ) : (
                  enabled
                )}
              </Button>
            </div>
            {/* </div> */}
            {/* </div> */}
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default TotpAuth
